import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { CustomInputComponent } from './custom-input.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    MatInputModule
  ],
  exports: [
    CustomInputComponent
  ],
  declarations: [CustomInputComponent]
})
export class CustomInputModule { }
